function mapOptions<
    NameProp extends string = 'name',
    IdProp extends string = 'id',
    Item extends Record<NameProp | IdProp, string> = Record<NameProp | IdProp, string>,
>({
    data = [],
    nameProp = 'name' as NameProp,
    idProp = 'id' as IdProp,
}: {
    nameProp?: NameProp;
    idProp?: IdProp;
    data?: Item[];
} = {}) {
    return data.map(item => ({
        name: item[nameProp],
        value: item[idProp],
    }));
}

export default mapOptions;
